import { LDPlugin, useLDFlag, useLDClient } from 'launchdarkly-vue-client-sdk';

export default defineNuxtPlugin((nuxtApp) => {
    const clientSideID = useRuntimeConfig().public.LAUNCH_DARKLY_CLIENT_KEY;
    try {
        let useLDFlagImplementation;
        let useLDClientImlementation;
        if (clientSideID && clientSideID !== 'XXXXXX') {
            nuxtApp.vueApp.use(LDPlugin, { clientSideID });
            useLDFlagImplementation = useLDFlag;
            useLDClientImlementation = useLDClient;
        } else {
            useLDFlagImplementation = (flagKey, defaultValue = false) => ref(defaultValue);
            useLDClientImlementation = () => ({
                track: () => {},
                flush: () => new Promise((resolve) => resolve('')),
                waitForInitialization: () => new Promise((resolve) => resolve('init')),
                identify: () => new Promise((resolve) => resolve({})),
                variationDetail: (flag) => ({ reason: { inExperiment: false } }),
                variation: (flag, defaultValue) => defaultValue,
            });
        }

        nuxtApp.provide('useLDFlag', useLDFlagImplementation);
        nuxtApp.provide('useLDClient', useLDClientImlementation);
    } catch (err) {
        console.error('Error initializing LaunchDarkly plugin:', err);
    }
});
